import { mountDrugDetailApp } from '../../tags/shared/mount_drug_modal';

mountDrugDetailApp('otc-drug-detail-app');
